import { STATUS_LIST_VOTES } from 'components/Modal/ComputeVotes/components/ListVotes/ListVotes';
import {
  COMPUTE_VOTES_AGENCIA_LOADING,
  COMPUTE_VOTES_AGENCIA_VALUES,
  COMPUTE_VOTES_LIST,
  COMPUTE_VOTES_LIST_LOADING,
  COMPUTE_VOTES_NUCLEOS_LOADING,
  COMPUTE_VOTES_NUCLEOS_VALUES,
  COMPUTE_VOTES_SET_FILTER,
} from './ComputeVotesActions';
import { COMPUTE_VOTES_PRESENCE_VOTES } from './ConfirmarPresencaActions';

export interface IProps {
  filter: {
    agencia: string;
    nucleos: string;
    idPauta: number;
  };
  agenciaOptions?: any;
  agenciaOptionsLoading: boolean;
  nucleosOptions?: any;
  nucleosOptionsLoading: boolean;
  items:
    | [
        {
          idItemPauta: number;
          descricao: string;
          quantidadeVotos: number | null;
          flgAclamacao: boolean;
          agencia: string;
          nucleo: string;
          status: STATUS_LIST_VOTES;
        }
      ]
    | [];
  itemsLoading: boolean;
  presenceVote:
    | {
        agencia: string;
        flagSemVotos: boolean;
        idPauta: number;
        itens: [
          {
            flagAclamacao: boolean;
            idItemPauta: number;
            quantidade: number;
          }
        ];
        nucleo: string;
      }
    | undefined;
}

export const INITIAL_STATE: IProps = {
  filter: {
    agencia: '',
    nucleos: '',
    idPauta: 0,
  },
  agenciaOptions: [],
  agenciaOptionsLoading: false,
  nucleosOptions: [],
  nucleosOptionsLoading: false,
  items: [],
  itemsLoading: false,
  presenceVote: undefined,
};

export default function ComputeVotesReducer(
  state: IProps,
  action: { type: any; payload?: any }
) {
  const { type, payload } = action;

  switch (type) {
    case COMPUTE_VOTES_SET_FILTER: {
      const newState: IProps = {
        ...state,
        filter: { ...state.filter, ...payload },
      };
      return newState;
    }
    case COMPUTE_VOTES_AGENCIA_VALUES: {
      const newState: IProps = { ...state, agenciaOptions: payload };
      return newState;
    }
    case COMPUTE_VOTES_LIST: {
      const newState: IProps = { ...state, items: payload };
      return newState;
    }
    case COMPUTE_VOTES_LIST_LOADING: {
      const newState: IProps = { ...state, itemsLoading: payload };
      return newState;
    }
    case COMPUTE_VOTES_AGENCIA_LOADING: {
      const newState: IProps = { ...state, agenciaOptionsLoading: payload };
      return newState;
    }
    case COMPUTE_VOTES_NUCLEOS_VALUES: {
      const newState: IProps = { ...state, nucleosOptions: payload };
      return newState;
    }
    case COMPUTE_VOTES_NUCLEOS_LOADING: {
      const newState: IProps = { ...state, nucleosOptionsLoading: payload };
      return newState;
    }
    case COMPUTE_VOTES_PRESENCE_VOTES: {
      const newState: IProps = { ...state, presenceVote: payload };
      return newState;
    }
    default:
      return state;
  }
}
